import { ShipmentSummary } from '~api/som_search';

import { Link as RouterLink } from 'react-router-dom';

import { Share16 } from '@ingrid/iconography/react';
import { Button, Card, DotBadge, ListLayout } from '@ingrid/luterkort-react';

import { LocalizedDate } from '~src/i18n/localized-date';
import { useTranslation } from '~src/i18n/use-translation';
import { useSiteId } from '~src/main/hooks/useSiteId';
import { AppRoute } from '~src/main/routes';
import { getStatusColor, getStatusLabel } from '~src/utils/status-helpers';

interface Props {
  shipments: ShipmentSummary[];
}

export function Shipments({ shipments }: Props) {
  const siteId = useSiteId();
  const { t } = useTranslation();

  if (!shipments.length) {
    return null;
  }

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.shipments')}</Card.Header>

      <Card.Content>
        <ListLayout.Column>
          {shipments.map(({ id, status, shipping_date }) => (
            <ListLayout.Row key={id} css={{ alignItems: 'center', display: 'flex' }}>
              <ListLayout.Stack>
                <ListLayout.PrimaryText>{id}</ListLayout.PrimaryText>

                <ListLayout.SecondaryText
                  {...(shipping_date && {
                    css: {
                      display: 'flex',
                      flexWrap: 'wrap',
                      rowGap: '0.5rem',
                      columnGap: '1.5rem',
                    },
                  })}
                >
                  <DotBadge variant={getStatusColor(status)}>{t(getStatusLabel(status))}</DotBadge>
                  {shipping_date && <LocalizedDate dateTime={shipping_date} size="sm" short time />}
                </ListLayout.SecondaryText>
              </ListLayout.Stack>

              <ListLayout.Actions>
                <Button
                  as={RouterLink}
                  to={`/${AppRoute.SITE}/${siteId}/${AppRoute.SHIPMENTS}/${id}`}
                  size="sm"
                  variant="tertiary"
                >
                  <Share16 />
                  {t('common.showDetails')}
                </Button>
              </ListLayout.Actions>
            </ListLayout.Row>
          ))}
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
